import request from '@/request'

/* 得到企业用户信息 */
export const getUserinfo = data => {
  return request({
    url: '/inf_FtuWxcpUser_Vipwd/getUserinfo.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到用户信息 */
export const getUserAccount = data => {
  return request({
    url: '/inf_FtuWxcpAccount_Vipwd/getUserAccount.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 更新用户信息 */
export const updateUserAccount = data => {
  return request({
    url: '/inf_FtuWxcpAccount_Vipwd/updateUserAccount.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到用户积分总信息 */
export const getintegral = data => {
  return request({
    url: '/inf_Credit/getAccountinfo.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 得到交易明细列表 */
export const getTradinglist = data => {
  return request({
    url: '/inf_Credit/getDetailList.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 获取签到记录 */
export const getSignlist = data => {
  return request({
    url: '/inf_Credit_Vipwd/getSignlist.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到连续签到情况 */
export const getSignData = data => {
  return request({
    url: '/inf_Credit_Vipwd/getSignData.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 添加积分 */
export const operateCredit = data => {
  return request({
    url: '/inf_Credit_Vipwd/addSignData.action',
    method: 'post',
    data: data,
    isMd5: true,
    noError: true
  })
}
/* 阅读新闻添加积分 */
export const operateCreditlist = data => {
  return request({
    url: '/inf_Credit_Vipwd/operateCredit.action',
    method: 'post',
    data: data,
    isMd5: true,
    noError: true
  })
}
/* 获取地址列表 */
export const getAddress = data => {
  return request({
    url: '/integral_address/list.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 获取默认地址 */
export const getAddressDefault = data => {
  return request({
    url: '/integral_address/getdefault.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 新增地址 */
export const addAddress = data => {
  return request({
    url: '/integral_address/add.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 删除地址 */
export const removeAddress = data => {
  return request({
    url: '/integral_address/delete.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 修改地址 */
export const editAddress = data => {
  return request({
    url: '/integral_address/edit.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 得到规则列表 */
export const getRuleList = data => {
  return request({
    url: '/inf_Credit/getRuleList.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 判断是否获得积分 */
export const checkCredit = data => {
  return request({
    url: '/inf_Credit_Vipwd/checkCredit.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
